export default __webpack_public_path__ + "b51dfbfceaf7f136fe335f242baaa7e5.svg";